function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import EventEmitter from 'eventemitter3';
import { removeDeepObserver } from '@netless/forge-room';
import { WhiteboardPermissionFlag } from '../WhitePermissions';
import { WhiteboardKeys } from '../WhiteboardKeys';
export class SelectElementsModel extends EventEmitter {
  get hasEditSelfPermission() {
    return this.hasPermission(WhiteboardPermissionFlag.editSelf);
  }
  get hasEditOthersPermission() {
    return this.hasPermission(WhiteboardPermissionFlag.editOthers);
  }
  constructor(userManager, requestUserMap, hasPermission) {
    super();
    _defineProperty(this, "requestUserMap", void 0);
    _defineProperty(this, "userManager", void 0);
    _defineProperty(this, "hasPermission", void 0);
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "handleUserLeave", user => {
      if (user.id === this.userManager.selfId) {
        return;
      }
      const cb = this.observers.get(user.id);
      if (cb) {
        removeDeepObserver(this.requestUserMap(user.id), cb);
        this.observers.delete(user.id);
      }
    });
    _defineProperty(this, "handleUserJoin", user => {
      const observer = evts => {
        this.handleUserSelectElementsChange(user.id, evts);
      };
      if (this.observers.has(user.id)) {
        removeDeepObserver(this.requestUserMap(user.id), this.observers.get(user.id));
        this.observers.delete(user.id);
      }
      this.requestUserMap(user.id).observeDeep(observer);
      this.observers.set(user.id, observer);
    });
    _defineProperty(this, "handleUserSelectElementsChange", (userId, evts) => {
      for (const evt of evts) {
        if (evt.target.get('inner-map-id') === WhiteboardKeys.selectElements) {
          const elementIds = Array.from(evt.target.keys()).filter(v => v !== 'inner-map-id');
          this.emit('elementsChange', userId, Array.from(elementIds));
        }
      }
    });
    this.hasPermission = hasPermission;
    this.userManager = userManager;
    this.requestUserMap = requestUserMap;
    this.createModel(this.userManager.selfId);
    this.userManager.userIdList().forEach(userId => {
      const observer = evts => {
        this.handleUserSelectElementsChange(userId, evts);
      };
      if (this.observers.has(userId)) {
        removeDeepObserver(this.requestUserMap(userId), this.observers.get(userId));
      }
      this.requestUserMap(userId).observeDeep(observer);
      this.observers.set(userId, observer);
    });
    this.userManager.on('join', this.handleUserJoin);
    this.userManager.on('leave', this.handleUserLeave);
  }
  createModel(userId) {
    const userMap = this.requestUserMap(userId);
    if (!userMap.has(WhiteboardKeys.selectElements)) {
      const ids = new Y.Map();
      ids.set('inner-map-id', WhiteboardKeys.selectElements);
      userMap.set(WhiteboardKeys.selectElements, ids);
    }
  }
  addSelectElementForSelf(elements) {
    const {
      hasEditSelfPermission,
      hasEditOthersPermission
    } = this;
    if (!this.requestUserMap(this.userManager.selfId).has(WhiteboardKeys.selectElements)) {
      return;
    }
    const ids = this.requestUserMap(this.userManager.selfId).get(WhiteboardKeys.selectElements);

    // 不能把别人正在删除中的元素或者已经选择的元素选中
    const ignoreIds = new Set();
    for (const userId of this.userManager.userIdList()) {
      if (userId !== this.userManager.selfId) {
        const userMap = this.requestUserMap(userId);
        if (!userMap.has('trashedElements') || !userMap.has(WhiteboardKeys.selectElements)) {
          continue;
        }
        const trashedIds = userMap.get('trashedElements');
        const selectedIds = userMap.get(WhiteboardKeys.selectElements);
        Array.from(trashedIds.keys()).forEach(key => ignoreIds.add(key));
        Array.from(selectedIds.keys()).forEach(key => ignoreIds.add(key));
      }
    }
    ids.doc.transact(() => {
      for (const element of elements) {
        if (element.ownerId === this.userManager.selfId && !hasEditSelfPermission) {
          continue;
        }
        if (element.ownerId !== this.userManager.selfId && !hasEditOthersPermission) {
          continue;
        }
        if (ignoreIds.has(element.elementId)) {
          continue;
        }
        if (!ids.has(element.elementId)) {
          ids.set(element.elementId, element.elementId);
        }
      }
    });
  }
  clearSelectElementForSelf() {
    const ids = this.requestUserMap(this.userManager.selfId).get(WhiteboardKeys.selectElements);
    ids?.doc?.transact(() => {
      ids.clear();
      ids.set('inner-map-id', WhiteboardKeys.selectElements);
    });
  }
  dispose() {
    for (const [key, value] of this.observers.entries()) {
      removeDeepObserver(this.requestUserMap(key), value);
    }
    this.observers.clear();
    this.userManager.off('leave', this.handleUserLeave);
    this.userManager.off('join', this.handleUserJoin);
  }
}